import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {ITooltipProps, Tooltip} from '@mintdata/mint-kit/impl/components/tooltip/Tooltip';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./MLogo.less');
const cx = classnames.bind(styles);

export interface LogoHeaderProps
{
    className?:string;
    iconClassName?:string;
    tooltipProps?:ITooltipProps;
}

@observer
export class MLogo extends React.Component<LogoHeaderProps, any>
{
    private _handleClick = (e:React.MouseEvent<HTMLAnchorElement>) =>
    {
        const isSampleDesign = !!rootState.ui.visualDesigner.sampleDesign;

        if( isSampleDesign )
        {
            e.stopPropagation();
            e.preventDefault();
            return;
        }

        controllers.navigation.toAppHome();
    };

    render()
    {
        const {className, iconClassName, tooltipProps} = this.props;
        const isSampleDesign = !!rootState.ui.visualDesigner.sampleDesign;

        const logo = (
            <a
                className={cx('base', {isSampleDesign}, className)}
                onClick={this._handleClick}
            >
                <MDIcon
                    className={cx('icon', iconClassName)}
                    name={MDIcons.logo.MintDataLogo2}
                />
            </a>
        );

        if( tooltipProps && !isSampleDesign )
        {
            const {popoverProps = {}} = tooltipProps;

            return (
                <Tooltip
                    tooltipClassName={cx('tooltip')}
                    showArrow={false}
                    closeOnTargetClick={true}
                    content={tooltipProps.content}
                    popoverProps={{
                        className: cx('tooltipPopover'),
                        sourceAnchor: SourceAnchor.LeftBottom,
                        popupAnchor: PopupAnchor.LeftTop,
                        ignoreEsc: true,
                        ...popoverProps
                    }}
                >
                    {logo}
                </Tooltip>
            );
        }

        return logo;
    }
}
